export const STRAPI_URL: string =
  import.meta.env.VITE_STRAPI_URL ?? "http://localhost:1337";
export const HOME_PORTAL_URL: string =
  import.meta.env.VITE_HOME_PORTAL_URL ?? "http://localhost:1338";

export const APP_INSIGHTS_CONNECTION_STRING = import.meta.env
  .VITE_APP_INSIGHTS_CONNECTION_STRING;
